export default "__VITE_ASSET__0779ae55__"